import { connectMediaStore } from './withOwnReduxStore';
import { setCurrentFolderId, unsetCurrentFolderId } from '../actions';
import { getCurrentGallection, getCurrentFolderId } from '../selectors';
export default (function (component) {
    return connectMediaStore(function (state) { return ({
        currentFolderId: getCurrentFolderId(state),
        currentGallection: getCurrentGallection(state),
    }); }, {
        setCurrentFolderId: setCurrentFolderId,
        unsetCurrentFolderId: unsetCurrentFolderId,
    })(component);
}); // redux typings are a bit dumb with generics
//# sourceMappingURL=withCurrentGallection.js.map